export default __webpack_public_path__ + "static/media/gun.3251827a.png";